document.addEventListener("DOMContentLoaded", function () {
  var sleep = 2500;
  var productGridContainer = document.querySelector(".product-grid-container");

  function isScrolledToBottom() {
    var containerRect = productGridContainer.getBoundingClientRect();
    var windowHeight =
      window.innerHeight || document.documentElement.clientHeight;
    return containerRect.bottom <= windowHeight;
  }

  function showElements(count) {
    var elementsToShow = document.querySelectorAll(".scroll-infinite.d-none");
    for (var i = 0; i < Math.min(count, elementsToShow.length); i++) {
      elementsToShow[i].classList.remove("d-none");
    }
  }

  function handleEvent() {
    setTimeout(() => {
      showElements(show_first);
    }, sleep);
  }

  function countElements() {
    var elementsCount = document.querySelectorAll(
      ".product-grid-container .scroll-infinite"
    ).length;
    var counterEl = document.querySelector("#ProductCountDesktop");

    if (counterEl) {
      counterEl.innerHTML = elementsCount + " products";
    } else {
      console.warn("⚠️ No existe #ProductCountDesktop en el DOM");
    }
  }
  var observer = new MutationObserver(function (mutationsList, observer) {
    for (var mutation of mutationsList) {
      if (mutation.type === "childList") {
        handleEvent();
      }
    }
  });

  var observerConfig = { childList: true, subtree: true };
  observer.observe(productGridContainer, observerConfig);

  function initializeScript() {
    observer.disconnect();

    document.addEventListener("scroll", function () {
      if (isScrolledToBottom()) {
        showElements(show_first);
      }
    });

    var eventElements = [
      { selector: 'input[type="checkbox"]', event: "click" },
      { selector: "#SortBy", event: "change" },
      { selector: ".active-facets__button-remove", event: "click" },
      { selector: "a", event: "click" },
    ];

    eventElements.forEach(function (element) {
      var elements = document.querySelectorAll(element.selector);
      elements.forEach(function (item) {
        item.addEventListener(element.event, handleEvent);
      });
    });

    showElements(show_first);

    observer.observe(productGridContainer, observerConfig);

    countElements();
  }

  initializeScript();
});
